import React from 'react'
import PropTypes from 'prop-types'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import Fallback from '@v4/components/common/WithLazy/components/Fallback'
import { Container } from '@mui/material'
import { MainContainerMinMarginsContextProvider } from './MainContainer.context'
import BaseContainer from '../BaseContainer'
import { useMainContainer } from './MainContainer.hooks'

const MainContainer = props => {
	const [{ minMarginBottom, minMarginTop, rootProps, margins, visible, ref, contentHeight }] = useMainContainer(props)

	return (
		<MainContainerMinMarginsContextProvider value={margins}>
			<BaseContainer
				{...rootProps}
				style={!visible && contentHeight ? { height: contentHeight, overflow: 'hidden' } : null}
				ref={ref}
				minMarginTop={minMarginTop}
				minMarginBottom={minMarginBottom}
			>
				{visible ? (
					rootProps.children
				) : (
					<Container>
						<Fallback />
					</Container>
				)}
			</BaseContainer>
		</MainContainerMinMarginsContextProvider>
	)
}

MainContainer.propTypes = {
	collection: PropTypes.string,
	relatedSections: PropTypes.arrayOf(
		PropTypes.oneOf([PageTemplateData.SORT_GROUPS.HEADER, PageTemplateData.SORT_GROUPS.FOOTER]),
	),
}

export default MainContainer
